module.exports = __webpack_public_path__ + "d.no1.3addfc63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/d.no1.jpg
// module id = q/lc
// module chunks = 0